import React from 'react'

const ShortcutNav = () => {
    return (
        <div className="sticky bottom-4">
            <div className="w-fit ml-auto mr-4">
                <div class="dropdown dropdown-top dropdown-end">
                    <label tabindex="0" class="btn btn-circle swap swap-rotate">
                        <svg
                            class="swap-off fill-current"
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 512 512"
                        >
                            <path d="M64,384H448V341.33H64Zm0-106.67H448V234.67H64ZM64,128v42.67H448V128Z" />
                        </svg>
                    </label>
                    <ul tabindex="0" class="dropdown-content menu p-2 shadow bg-neutral rounded-box w-52">
                        <li>
                            <a href="/">Home</a>
                        </li>
                        <li>
                            <a href="#service">Services</a>
                        </li>
                        <li>
                            <a href="#blogs">Blogs</a>
                        </li>
                        <li>
                            <a href="#project">Projects</a>
                        </li>
                        <li>
                            <a href="#skill">Skill</a>
                        </li>
                        <li>
                            <a href="#about">About</a>
                        </li>
                        <li>
                            <a href="#contact">Contact</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ShortcutNav
